import { Typography, Grid, Box } from "@mui/material";

const ContactSection = () => {

    const contactInfo = [
        {
            icon: "/img/mail.png",
            alt: "Email icon",
            text: <>
                info<span style={{ fontFamily: 'Arial, sans-serif', fontWeight: 100 }}>@</span>gcbuildersllc.com
            </>
        },
        {
            icon: "/img/pin_drop.png",
            alt: "Location icon",
            text: "1200 Brickell Ave., Suite 1660 Zip 33131, FL, USA",
        },
        {
            icon: "/img/call.png",
            alt: "Phone icon",
            text: "305-456-7676",
        },
        {
            icon: "/img/id_card.png",
            alt: "Verified User icon",
            text: "General Contractor - CGC 1534541",
        },
    ];

    return (
        <Box id="contact" style={{ backgroundColor: "#F1F1F2", padding: "4rem 1rem" }}>
            <Grid container spacing={10} alignItems="center">
                <Grid item xs={12} md={5}>
                    <Box
                        sx={{
                            height: "300px",
                            backgroundImage: "url('/img/builders-international.png')",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: { xs: "center", md: "right" },
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={7}>
                    <Typography variant="h2" marginBottom={2} textAlign={{ xs: 'center', md: 'inherit' }}>
                        CONTACT US
                    </Typography>
                    <Typography variant="h3" marginBottom={3} style={{ fontSize: "30px", fontWeight: "bold", lineHeight: 1, letterSpacing: 1, width: '80%' }}>
                        Get in touch today to discuss how we can elevate your project with our expertise.
                    </Typography>

                    {contactInfo.map((item, index) => (
                        <Typography key={index} variant="body2" fontSize='20px' marginBottom={1} fontWeight='bold' style={{ display: "flex", alignItems: "center", fontFamily: 'NexaTextDemo, Arial, sans-serif', fontVariantLigatures: 'none' }}>
                            <Box
                                component="img"
                                src={item.icon}
                                alt={item.alt}
                                style={{ width: "34px", height: "34px", marginRight: "10px" }}
                            />

                            {item.text}
                        </Typography>
                    ))}
                </Grid>
            </Grid>
        </Box>
    )
}

export default ContactSection;